export enum TPopupVertical {
  Top = 'top',
  Center = 'center',
  Bottom = 'bottom',
}
export enum TPopupHorizontal {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export interface IPosition {
  left?: number
  right?: number
  top?: number
  bottom?: number
  width?: number
  height?: number
}

export type TPosition = 'fixed' | 'absolute'

export interface IPositionStyles {
  left?: string
  right?: string
  top?: string
  bottom?: string
  width?: string
  height?: string
  position?: TPosition
}
